import {
  ENV,
  LONGNOW_API_DOMAIN,
  GHOST_API_DOMAIN,
  GHOST_API_KEY,
} from "../env";
import Cookies from "js-cookie";

const debug = ENV == "development" ? true : false;
const GET = "GET";
const POST = "POST";
const PUT = "PUT";

const fetchData = async ({ path, method, body, csrf, onError }) => {
  debug && console.log("FETCH BODY:");
  debug && console.log(body);
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (csrf) {
    headers["X-CSRFToken"] = Cookies.get("csrftoken");
  }
  const handleResponse = (response) => {
    return response.json().then((json) => {
      if (response.ok) {
        return json;
      } else {
        return Promise.reject(json);
      }
    });
  };
  const response = await fetch(path, {
    method: method,
    body: !!body ? JSON.stringify(body) : null,
    headers: headers,
  })
    .then(handleResponse)
    .then((data) => {
      if (data.errors) {
        debug && console.log("DATA ERROR");
        debug && console.log(data.errors);
        return onError(data.errors);
      } else {
        debug && console.log("DATA SUCCESS:");
        debug && console.log(data);
        return data;
      }
    })
    .catch((error) => {
      debug && console.log("FETCH ERROR");
      debug && console.log(error);
      return onError(error);
    });
  return response;
};

export function useApi(onError) {
  return {
    get: (path, csrf) =>
      fetchData({
        path: `${LONGNOW_API_DOMAIN}/api/v1/${path}`,
        method: GET,
        body: null,
        csrf: csrf,
        onError: onError,
      }),
    post: (path, body, csrf) =>
      fetchData({
        path: `${LONGNOW_API_DOMAIN}/api/v1/${path}`,
        method: POST,
        body: body,
        csrf: csrf,
        onError: onError,
      }),
    put: (path, body, csrf) =>
      fetchData({
        path: `${LONGNOW_API_DOMAIN}/api/v1/${path}`,
        method: PUT,
        body: body,
        csrf: csrf,
        onError: onError,
      }),
    ghost: (path) =>
      fetchData({
        path: `${GHOST_API_DOMAIN}/ghost/api/content/${path}?key=${GHOST_API_KEY}`,
        method: GET,
        body: null,
        csrf: null,
        onError: onError,
      }),
  };
}
export default useApi;
